import Swiper, { Navigation, Pagination } from 'swiper'
import '@fancyapps/fancybox'

export default () => {
  if ($('.stb-product-gallery').length) {
    new Swiper('.stb-product-gallery', {
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: '.stb-product-gallery__pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.stb-product-gallery__next',
        prevEl: '.stb-product-gallery__prev',
      },
      modules: [Pagination, Navigation],
      resizeObserver: true,
    })
  }

  $('[data-fancybox]').fancybox({
    buttons: ['close'],
    wheel: false,
    transitionEffect: 'slide',
    loop: true,
    toolbar: true,
    clickContent: true,
  })

  /**
   * Variation selected
  */
  $('.variations tbody tr').each((index, el) => {
    const _self = $(el)
    const valueSelected = _self.find('select').val()

    if (valueSelected) {
      _self.find(`.stb-product-variants__item[data-value="${valueSelected}"]`).addClass('selected')
    }
  })

  $('.stb-product-variants .stb-product-variants__item').click((e) => {
    const _self = $(e.currentTarget)
    const parent = _self.parents('td')
    parent.find('.selected').removeClass('selected')
    _self.addClass('selected')
    const attrSlug = _self.data('value')
    parent.find('select').val(attrSlug).change()
  })

  $('.reset_variations').click(() => {
    $('.stb-product-variants .selected').removeClass('selected')
    const swiper = document.querySelector('.stb-product-gallery').swiper
    swiper.slideTo(0)
  })

  $( '.single_variation_wrap' ).on( 'show_variation', function ( event, variation ) {
    const swiper = document.querySelector('.stb-product-gallery').swiper
    if (variation.image_id) {
      const imgIndex = $(swiper.$wrapperEl).find(`.image-id-${variation.image_id}`).index()
      swiper.slideTo(imgIndex)
    }

    // Change price
    if (variation.price_html) {
      $('.summary .price').html(variation.price_html)
    }
  })

  /**
   * Action click zoom icon
  */
  $('.stb-product-gallery__zoom-img').click(() => {
    $('.stb-product-gallery .swiper-slide-active a').trigger('click')
  })

  /**
   * Product related slide
  */
  if ($('.stb-product-related').length) {
    new Swiper('.stb-product-related', {
      spaceBetween: 0,
      centeredSlides: false,
      loop: false,
      direction: 'horizontal',
      loopedSlides: 3,
      pagination: {
        el: '.stb-product-related__pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.stb-product-related__next',
        prevEl: '.stb-product-related__prev',
      },
      resizeObserver: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        // when window width is >= 992px
        1000: {
          slidesPerView: 3,
          spaceBetween: 63,
        },
      },
    })
  }

  /**
   * Product tabs
  */
  $('.stb-product-tabs .tab-title').click((e) => {
    const _self = $(e.currentTarget)
    const tabPanelID = $('a' ,_self).attr('href')
    _self.toggleClass('open')
    $(tabPanelID).toggleClass('open')
  })
}
